import { addEventToDataLayerGT3 } from "@website/tracking/tracking.gtm";
import { DATA_LAYER_EVENTS } from "@website/tracking/tracking.types";
import { datalayerAppName } from "@website/widget/telesales/constants";
import { TelesalesAppName } from "@website/widget/telesales/types";
import toNumber from "lodash-es/toNumber";
import { useCallback, useState } from "react";

export const useTelesales = (storageKey: string, app: TelesalesAppName) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [isSubmitBefore, setIsSubmitBefore] = useState<boolean>(false);
  const handleOpenModal = useCallback(() => {
    setIsOpenModal(true);
    addEventToDataLayerGT3(DATA_LAYER_EVENTS.TELESALES_BUTTON_CLICK, {
      item: [
        {
          item_brand: datalayerAppName[app]
        }
      ]
    });
    const timestamp = toNumber(localStorage.getItem(storageKey));
    setIsSubmitBefore(
      Boolean(timestamp) && Date.now() - timestamp <= 10_800_000
    );
  }, [app, storageKey]);

  return {
    isOpenModal,
    setIsOpenModal,
    handleOpenModal,
    isSubmitBefore
  };
};
